import { useMemo } from 'react'

import { BoxShadowSize, ButtonType } from 'src/apollo/sites'

import { useOptionalRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

export const BOX_SHADOWS: Partial<Record<BoxShadowSize, string>> = {
  [BoxShadowSize.None]: 'none',
  [BoxShadowSize.Sm]: '0 2px 8px rgba(0, 0, 0, 0.12)',
  [BoxShadowSize.Md]: '0 4px 12px rgba(0, 0, 0, 0.20)'
}

const DEFAULTS = {
  borderRadius: 99,
  boxShadowSize: BoxShadowSize.None,
  showBorder: true,
  borderWidth: 2
}

export const useButtonsConfig = (variant?: ButtonType | null) => {
  const context = useOptionalRestaurant()
  const restaurant = context?.restaurant
  const buttonsConfig = restaurant?.config?.buttonsConfig

  return useMemo(() => {
    /**
     * Primary and Inverted buttons use the same config
     * Text variant does not use BrandedButton and thus can be ignored
     */

    const isSecondary = variant === ButtonType.Secondary
    const buttonConfig = isSecondary
      ? buttonsConfig?.secondaryButton
      : buttonsConfig?.primaryButton

    const bsc = buttonConfig?.borderAndShadowConfig
    // only secondary button has default border/border width
    const showBorder =
      bsc?.showBorder ?? (isSecondary ? DEFAULTS.showBorder : false)

    // TODO: remove once buttons are set to fixed 48px height
    const secondaryBsc = buttonsConfig?.secondaryButton?.borderAndShadowConfig
    const secondaryShowBorder = secondaryBsc?.showBorder ?? DEFAULTS.showBorder
    const borderWidth = secondaryShowBorder
      ? secondaryBsc?.borderWidth ?? DEFAULTS.borderWidth
      : undefined
    const isTinted = isSecondary && !showBorder

    return {
      // backwards compatible
      borderRadius: bsc?.borderRadius ?? DEFAULTS.borderRadius,
      // backwards compatible
      boxShadow: BOX_SHADOWS[bsc?.boxShadowSize ?? DEFAULTS.boxShadowSize],
      showBorder,
      borderWidth,
      isTinted
    }
  }, [buttonsConfig, variant])
}
